
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

import Picker from "./Picker.vue";
import Preview from "./Preview.vue";
import Hue from "./Hue.vue";
import Alpha from "./Alpha.vue";
import GradientPoints from "./GradientPoints.vue";
import { GradientPoint } from "@/types/colors";

@Component({
  components: {
    Picker,
    Preview,
    Hue,
    Alpha,
    GradientPoints
  }
})
export default class Area extends Vue {
  @Prop()
  red!: number;

  @Prop()
  green!: number;

  @Prop()
  blue!: number;

  @Prop()
  alpha!: number;

  @Prop()
  hue!: number;

  @Prop()
  saturation!: number;

  @Prop()
  value!: number;

  @Prop()
  updateColor!: Function;

  @Prop()
  points!: GradientPoint[];

  @Prop()
  degree!: number;

  @Prop()
  type!: string;

  @Prop()
  activePointIndex!: number;

  @Prop()
  changeGradientControl!: Function;

  @Prop()
  changeActivePointIndex!: Function;

  @Prop()
  updateGradientLeft!: Function;

  @Prop()
  addPoint!: Function;

  @Prop()
  removePoint!: Function;
}
